import CrossSelling from 'pages/BackOfficePage/BackOfficeCategories/CrossSelling/CrossSelling';

export default CrossSelling;
